import React, { FC } from 'react';
import styles from '../../styledComponents/';
import ChangePassword from './changePassword';
import ScanLoginWidget from '../ScanLoginWidget';
const { PageWrapper, PageHeader } = styles;
const AccountHome: FC = () => {
  return (
    <PageWrapper>
      <PageHeader>Account</PageHeader>
      <ChangePassword></ChangePassword>
      <ScanLoginWidget />
    </PageWrapper>
  );
};

export default AccountHome;
